import { DoorConfiguration } from './DoorConfiguration';
export class MainNavigationFilter {
    private mainNvaigation: any[];

    private mainNavigationObject: any = {
        modelSelectionClassObject: {},
        functionsClassObject: {},
        frameClassObject: {},
        measureClassObject: {},
        doorLeafClassObject: {},
        exteriorAccessClassObject: {},
        mountingMaterialClassObject: {},
        blindstockMultiClassObject: {},
        furtherInfoClassObject: {},
    };

    public constructor(mainNvaigation: any[]) {
        this.mainNvaigation = mainNvaigation;
    }

    // not final
    public MainNavigationItemsFilter(navigation: any[]) {
        this.mainNvaigation.forEach((element) => {
            const nav = navigation.filter((x) => x.code === element.name)[0];

            if (nav.success === true) {
                element.disabled = false;
            } else {
                element.disabled = true;
            }
        });

        return this.mainNvaigation;
    }

    public MainNavigationItemsDisable(navigation: any){
        const foundIndex = this.mainNvaigation.findIndex(f => f.itemId === navigation.itemId)
        if (foundIndex)
            this.mainNvaigation.filter((f: any, index) => index > foundIndex).forEach(a => a.disabled = true)
    }

    public UpdateMainNavigation(navigation: any[], mainNavId: number, updatePrev: boolean = true, resetInitial: boolean = false) {

        const mainNavItem = this.mainNvaigation.filter((x) => x.itemId === mainNavId)[0];
        let notCompleted: boolean = false;
        let mainNavItemState: boolean = true;
        
        if (mainNavId === 1 || mainNavId === 2) {
            navigation.filter(item => {
                return item.required;
            }).forEach((element) => {
                if (element.success === true) {
                    mainNavItemState = false;
                } else {
                    mainNavItemState = true;
                    element.success = false;
                    if (resetInitial === true) {
                        element.warning = false;
                    } else {
                        element.warning = true;
                    }
                    notCompleted = true;
                }
            });
        } else if (mainNavId === 3 || mainNavId === 5 || mainNavId === 6 || mainNavId === 7) {
            navigation.filter(item => {
                return item.required;
            }).forEach(element => {
                if (element.completed() === false) 
                    notCompleted = true;
            });
        } else if(mainNavId === 10){
            Object.entries(navigation).forEach( e => {
                const [key, value] = e;
                if(value === null || value === "")
                    notCompleted = true;
            })
        }

        // if (!mainNavItemState) {
        let mainNavId2: number;

        if (updatePrev === false) {
            mainNavId2 = mainNavId;
        } else {
            mainNavId2 = mainNavId - 1;

            if (mainNavId2 === 0) {
                const mainNavItem1 = this.mainNvaigation.filter((x) => x.itemId === mainNavId)[0];
                if (typeof mainNavItem1 !== 'undefined') {
                    mainNavItem1.active = !notCompleted;
                }
            }
        }

        const mainNavItem1 = this.mainNvaigation.filter((x) => x.itemId === mainNavId2)[0];
        if (typeof mainNavItem1 !== 'undefined') {
            if (updatePrev === false)
                mainNavItem.active = false;
            else
                mainNavItem1.active = !notCompleted;            
        }

        if (mainNavId === 1 || mainNavId === 2) {
            mainNavItem.disabled = notCompleted;
        } else if(mainNavId !== 10) {
            mainNavItem.disabled = notCompleted;
        }
        if(mainNavId === 1){
            mainNavItem.disabled = false;
        }
        
        return this.mainNvaigation;
    }

    public ResetMainNavigationItemStatus(mainNavId: number, state: boolean) {
        const mainNavItem = this.mainNvaigation.filter((x) => x.itemId === mainNavId)[0];
        mainNavItem.active = state;
        return this.mainNvaigation;
    }
}

export const mainNavigationItems = [
    {
        displayText: 'variantenauswahl',
        icon: '1',
        name: 'ModelSelection',
        disabled: false,
        active: false,
        itemId: 1,
        route: '/model-selection'
    },
    {
        displayText: 'funktionsauswahl',
        icon: '2',
        name: 'Functions',
        disabled: true,
        active: false,
        itemId: 2,
        route: '/functions',
    },
    {
        displayText: 'zargenauswahl',
        icon: '3',
        name: 'Frame',
        disabled: true,
        active: false,
        itemId: 3,
        route: '/frame',
    },
    {
        displayText: 'massblatt',
        icon: '4',
        name: 'Measure',
        disabled: true,
        active: false,
        itemId: 4,
        route: '/measure',
    },
    {
        displayText: 'turblattOberflache',
        icon: '5',
        name: 'DoorLeafSurface',
        disabled: true,
        active: false,
        itemId: 5,
        route: '/door-leaf-surface',
    },
    {
        displayText: 'zubehoer',
        icon: '6',
        name: 'ExteriorAccessory',
        disabled: true,
        active: false,
        itemId: 6,
        route: '/exterior-accessory',
    },
    {
        displayText: 'montagematerial',
        icon: '7',
        name: 'MountingMaterial',
        disabled: true,
        active: false,
        itemId: 7,
        route: '/mounting-material',
    },
    {
        displayText: 'blindstockmultiplex',
        icon: '8',
        name: 'BlindstockMultiplex',
        disabled: true,
        active: false,
        itemId: 8,
        route: '/blindstock-multiplex',
    },
    {
        displayText: 'zusatzinformationen',
        icon: '9',
        name: 'FurtherInfo',
        disabled: true,
        active: false,
        itemId: 9,
        route: '/further-info',
    },
];

export const mainNavigationItemsInit = [
    {
        displayText: 'variantenauswahl',
        icon: 'mdi-vector-selection',
        name: 'ModelSelection',
        disabled: false,
        active: false,
        itemId: 1,
        route: '/model-selection',
    },
    {
        displayText: 'funktionsauswahl',
        icon: 'mdi-format-list-bulleted',
        name: 'Functions',
        disabled: true,
        active: false,
        itemId: 2,
        route: '/functions',
    },
    {
        displayText: 'zargenauswahl',
        icon: 'mdi-fullscreen',
        name: 'Frame',
        disabled: true,
        active: false,
        itemId: 3,
        route: '/frame',
    },
    {
        displayText: 'massblatt',
        icon: 'mdi-ruler-square',
        name: 'Measure',
        disabled: true,
        active: false,
        itemId: 4,
        route: '/measure',
    },
    {
        displayText: 'turblattOberflache',
        icon: 'mdi-texture-box',
        name: 'DoorLeafSurface',
        disabled: true,
        active: false,
        itemId: 5,
        route: '/door-leaf-surface',
    },
    {
        displayText: 'zubehoer',
        icon: 'mdi-cogs',
        name: 'ExteriorAccessory',
        disabled: true,
        active: false,
        itemId: 6,
        route: '/exterior-accessory',
    },
    {
        displayText: 'montagematerial',
        icon: 'mdi-texture',
        name: 'MountingMaterial',
        disabled: true,
        active: false,
        itemId: 7,
        route: '/mounting-material',
    },
    {
        displayText: 'blindstockmultiplex',
        icon: 'mdi-blinds-open',
        name: 'BlindstockMultiplex',
        disabled: true,
        active: false,
        itemId: 8,
        route: '/blindstock-multiplex',
    },
    {
        displayText: 'zusatzinformationen',
        icon: 'mdi-information-outline',
        name: 'FurtherInfo',
        disabled: true,
        active: false,
        itemId: 9,
        route: '/further-info',
    },
];

